// Função para limpar todos os dados de autenticação
const clearAuthData = () => {
  localStorage.removeItem("rh-user");
  localStorage.removeItem("rh-userName");
  localStorage.removeItem("rh-userId");
  localStorage.removeItem("rh-email");
  localStorage.removeItem("rh-key");
  localStorage.removeItem("rh-token");
  localStorage.removeItem("rh-refreshToken");
  localStorage.removeItem("rh-tokenExpire");
  localStorage.removeItem("rh-permissions");
  localStorage.removeItem("authkey");
};

export default async function sessionInterceptor(response: Response) {
  if (response.status === 401) {
    console.warn("Sessão expirada - limpando dados de autenticação");

    // Limpar dados de autenticação
    clearAuthData();

    // Redirecionar para login
    window.location.replace("/login");
    return;
  }
}
